// ==============================|| FERRY ICON ||============================== //

const FerryIcon = ({ color = '#3b66b0', width = 24, className = '' }) => {
  const commonStyle = {
    fill: color,
    strokeWidth: '0px',
  };

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.3,18.5l-1.7-6c0-.2,0-.4,0-.6,0-.2.2-.4.5-.5l1.3-.5v-4.5c0-.5.2-.9.5-1.3s.8-.5,1.3-.5h3.2V1.7h5v3h3.2c.5,0,.9.2,1.3.5s.5.8.5,1.3v4.5l1.3.5c.3.1.5.3.5.5,0,.2,0,.4,0,.6l-1.7,6c-.7,0-1.4-.3-2-.7-.6-.4-1.2-.9-1.7-1.5-.5.6-1.1,1.2-1.8,1.6-.7.4-1.4.7-2.2.7s-1.6-.2-2.2-.7c-.7-.4-1.3-1-1.8-1.6-.6.6-1.1,1.1-1.7,1.5-.6.4-1.2.6-2,.7ZM2.3,22.5v-1.5h1.8c.7,0,1.4-.1,2.1-.3.7-.2,1.3-.5,1.9-1,.6.4,1.2.8,1.9,1s1.4.3,2.1.3,1.4-.1,2.1-.3,1.3-.5,1.9-1c.6.4,1.2.8,1.9,1,.7.2,1.4.3,2.1.3h1.8v1.5h-1.8c-.7,0-1.4,0-2.1-.3-.7-.2-1.3-.4-2-.8-.6.3-1.3.6-2,.8-.7.2-1.4.3-2,.3s-1.4,0-2-.3c-.7-.2-1.3-.4-2-.8-.6.3-1.3.6-2,.8s-1.4.3-2.1.3h-1.8ZM6,10.5l6-2,6,2v-4c0,0,0-.2,0-.2,0,0-.1,0-.2,0H6.3c0,0-.2,0-.2,0,0,0,0,.1,0,.2v4ZM12,17c.8,0,1.4-.3,2-.8.5-.5,1.2-1.3,2-2.2.8.9,1.3,1.5,1.6,1.8.3.3.6.6,1,.8l1.1-4-7.8-2.6-7.8,2.6,1.1,4c.4-.2.7-.5,1-.8.3-.3.8-.9,1.6-1.9.8,1,1.5,1.7,2,2.2s1.2.8,2,.8Z"
        style={commonStyle}
      />
    </svg>
  );
};

export default FerryIcon;
